// src/pages/PrivacyPage.jsx
import React from "react";

const SUPPORT_EMAIL = "support@starepochlabs.com";
const LAST_UPDATED = "2026-01-22";

export default function PrivacyPage() {
  return (
    <div className="space-y-10">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-10">
        <p className="text-sm font-semibold text-cyan-300/90 text-center">
          Privacy Policy
        </p>

        <h2 className="mt-3 text-center text-3xl font-semibold tracking-tight text-white">
          Privacy, explained clearly
        </h2>

        <p className="mt-4 mx-auto max-w-3xl text-center text-base leading-7 text-white/75">
          StarEpoch Labs respects your privacy. This policy explains what information we may
          collect, why we collect it, how it is used, and the choices available to you.
          (Last updated: <b>{LAST_UPDATED}</b>)
        </p>

        <div className="mt-8 mx-auto grid max-w-3xl gap-6">
          {/* Collect */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">
              Information we may collect
            </div>
            <p className="mt-2 text-sm text-white/70">
              We collect only what is necessary to operate our services, provide support, and
              maintain reliability.
            </p>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>
                • Contact information you voluntarily provide, such as email when you reach out
                for support.
              </li>
              <li>
                • Transaction and billing status provided by the App Store when applicable
                (we do not receive your full payment card details).
              </li>
              <li>
                • Limited diagnostic data to help improve stability and security (for example:
                crash reports or error logs), when available on your device or platform.
              </li>
            </ul>
          </div>

          {/* Don't */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">
              What we do not do
            </div>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>• We do not sell personal information.</li>
              <li>
                • We do not use the content of your network traffic for advertising.
              </li>
              <li>
                • We do not share personal information with third parties for their marketing purposes.
              </li>
            </ul>
          </div>

          {/* Use / share */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">
              How we use information
            </div>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>• To provide customer support and respond to requests.</li>
              <li>• To operate, maintain, and improve service reliability and security.</li>
              <li>
                • To comply with applicable laws or lawful requests where required.
              </li>
            </ul>
            <p className="mt-3 text-sm text-white/70">
              We may use service providers to help us operate (for example, email delivery).
              They are permitted to process data only to perform services for us and must protect it.
            </p>
          </div>

          {/* Retention */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">
              Retention and security
            </div>
            <p className="mt-3 text-sm text-white/70">
              We retain information only as long as necessary for the purposes described above,
              or as required by law. We use reasonable administrative, technical, and organizational
              measures to protect information from unauthorized access, disclosure, alteration, or destruction.
            </p>
          </div>

          {/* Contact */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Contact</div>
            <div className="mt-3 text-sm text-white/70">
              For privacy questions or requests, contact{" "}
              <a className="text-white hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
              .
            </div>
          </div>
        </div>

        <div className="mt-6 text-xs text-white/50">
          Note: This policy is intended to be clear and readable. Final details should reflect
          the actual app implementation and any third-party services you use.
        </div>
      </section>
    </div>
  );
}

